<div class="card-box"
  (click)="handleViewTaxonomy($event, taxonomy.taxonomy_id, taxonomy.taxonomy_name, taxonomy.version_history_details, taxonomy.version_history_details[0])">
  <!-- Header Section -->
  <div class="header-section">
    <!-- Taxonomy Header -->
    <div class="header-title">
      <!-- Taxonomy Name -->
      <div class="name-section" [matTooltip]="isTaxonomyNameTruncated() ? taxonomy.taxonomy_name : ''">
        <span #taxonomyName>
          {{ taxonomy.taxonomy_name }}
        </span>
      </div>
      <!-- Tag division -->
      <div class="tag-container" [ngClass]="getTagClass()">
        <span *ngIf="!isPublished">{{ getTagText() }}</span>
        <span *ngIf="isPublished" class="published-tag">
          <span class="published-text">Published</span>
          <span class="separator">•</span>
          <span class="version-text">{{ getPublishedVersionNumber() }}</span>
        </span>
      </div>
    </div>
    <!-- More Options -->
    <div class="more-section">
      <button class="btn-more" [matMenuTriggerFor]="moreMenu" #moreMenuTrigger="matMenuTrigger"
        (click)="$event.stopPropagation()">
        <img src="assets/icons/more_vert.svg" alt="more-icon">
      </button>

      <mat-menu #moreMenu="matMenu">
        <button mat-menu-item (click)="handleConfigureClick($event, taxonomy.taxonomy_id)">
          <img src="assets/icons/configure-taxonomy.svg" alt="configure-icon" class="menu-icon">
          <span>Configure</span>
        </button>
        <button mat-menu-item
          (click)="handleCloneClick($event, taxonomy.taxonomy_id, taxonomy.taxonomy_name, taxonomy.version_history_details)">
          <img src="assets/icons/clone-taxonomy.svg" alt="clone-icon" class="menu-icon">
          <span>Clone</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <!-- Description Section -->
  <div class="description-section"
    [matTooltip]="isTaxonomyDescriptionTruncated() ? (taxonomy.taxonomy_description || '-') : ''">
    <span #taxonomyDescription>
      {{ taxonomy.taxonomy_description || '-' }}
    </span>
  </div>

  <!-- Action Section -->
  <div class="action-section">
    <div class="taxonomy-meta">
      <div class="divider"></div>
      <div class="taxonomy-owner-section">
        <span class="taxonomy-owner">Taxonomy Owner:</span> <span class="value">{{taxonomy.taxonomy_owner_name}}</span>
      </div>
    </div>
  </div>
